<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiPlusCircle } from "@mdi/js"

export default {
  name: "PlusCircleIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiPlusCircle,
    }
  }
}
</script>
